<template>
  <div class="matrixx w-100">
    <MatrixxGrid :question="question" @matrixx-value-changed="handleMatrixValueChanged" />
  </div>
</template>
<script lang="ts">
import { mapState } from 'pinia'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'
import { useValidationStore } from '@/survey/stores/ValidationStore.ts'
import MatrixxGrid from '@app/components/MatrixxGrid.vue'

export default {
  components: { MatrixxGrid },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Stores the selected rows and answers.
      // Structure: { matrixRowId: matrixAnswerId }
      selectedAnswersIds: {},
    }
  },
  mounted() {
    this.registerValidationFunction(this.question.id, this._validate)
    this.question.rows.forEach((row) => {
      const response = this.findResponseByQuestionId(row.id)
      if (response) {
        this.selectedAnswersIds[row.id] = response.answer_id
      }
    })
  },
  computed: {
    ...mapState(useSurveyResponseStore, ['surveyResponses', 'findResponseByQuestionId']),
    ...mapState(useValidationStore, [
      'addError',
      'clearErrors',
      'registerValidationFunction',
      'validate',
    ]),
    isAllQuestionsAnswered() {
      return this.question.rows.length === Object.keys(this.selectedAnswersIds).length
    },
  },
  methods: {
    handleMatrixValueChanged(updatedRow) {
      const existingResponse = this.findResponseByQuestionId(updatedRow['questionId'])
      const responseData = {
        question_id: updatedRow['questionId'],
        response_id: existingResponse?.id,
        answer_id: updatedRow['answerId'],
        value_answer: null,
      }

      this.selectedAnswersIds[updatedRow['questionId']] = updatedRow['answerId']
      this.selectedAnswersIds = { ...this.selectedAnswersIds } // force reactivity

      if (this.isAllQuestionsAnswered) this.clearErrors(this.question.id)

      this.$emit('change', responseData)
    },
    _validate() {
      if (this.question.required && !this.isAllQuestionsAnswered) {
        this.addError(this.question.id, 'Please answer all the questions')
      }
    },
  },
}
</script>
